// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import bklEntity from './entities/bkl.json';
import bklMenu from '../pages/bkl/menu.json';
import bklFullForm from '../pages/bkl/forms/full.json';
import bklContextForm from '../pages/bkl/forms/context.json';
import bklMiniForm from '../pages/bkl/forms/mini.json';
import bklLookupForm from '../pages/bkl/forms/lookup.json';
import bklTableView from '../pages/bkl/views/table.json';
import bklStagesView from '../pages/bkl/views/stages.json';
import bklCardsView from '../pages/bkl/views/cards.json';
import bklInlineView from '../pages/bkl/views/inline.json';
import bklBacklogView from '../pages/bkl/views/backlog.json';
import bklSplitView from '../pages/bkl/views/split.json';
import bklCalendarView from '../pages/bkl/views/calendar.json';
import bklDashboardView from '../pages/bkl/views/dashboard.json';

/** Тип запису «Беклог» зі сторінками пакета: меню, форми та подання з pages/bkl/. */
export const bklDefinition: IRecordTypeDefinition = {
  ...bklEntity,
  views: assembleViewSet({
      table: bklTableView,
      stages: bklStagesView,
      cards: bklCardsView,
      inline: bklInlineView,
      backlog: bklBacklogView,
      split: bklSplitView,
      calendar: bklCalendarView,
      dashboard: bklDashboardView,
  }),
  form: bklFullForm,
  forms: { full: bklFullForm, context: bklContextForm, mini: bklMiniForm, lookup: bklLookupForm },
  menu: bklMenu,
} as IRecordTypeDefinition;
